/* src/app/shared/components/new-infobox/new-infobox.component.scss */
.info-box {
  max-width: 1200px;
  width: 100%;
  background-color: #e4d7f3;
  border-radius: 12px;
  margin-bottom: 24px;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  overflow: hidden;
  position: relative;
}
.content {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 24px;
}
.info-container {
  display: flex;
  flex-direction: column;
  width: 70%;
}
.SemiBold {
  color: #222222;
  font-family: "Poppins-Medium";
  font-size: 32px;
  font-style: normal;
  line-height: 140%;
}
.Regular {
  display: flex;
  max-width: 808px;
  width: 100%;
  color: #222222;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
}
.image {
  width: auto;
  height: 360px;
  flex-shrink: 0;
  position: absolute;
  margin-left: auto;
}
/*# sourceMappingURL=new-infobox.component.css.map */
